import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ControlContainer, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { Subject } from 'rxjs';
import { TimeApiService } from 'cbc-shared-lib';
import { Sgkb702aResInclusioncontractInclutagsupdemandctrSearchresultDto,
  Sgkb702aResInclusiveCtrInfoDto } from 'sg-api';

@Component({
  selector: 'app-sgkb708d-appliinfo',
  templateUrl: './sgkb708d-appliinfo.component.html',
  styleUrl: './sgkb708d-appliinfo.component.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class Sgkb708dAppliinfoComponent implements OnInit, OnDestroy {

  /** 遷移元ステータス */
  @Input() mode : string;
  /** 包括契約検索APIレスポンス */
  @Input() incCtrSearchresult : Sgkb702aResInclusioncontractInclutagsupdemandctrSearchresultDto;

  /** 親コンポーネント保持領域 */
  parentForm: UntypedFormGroup | null = null;

  /** 検索情報格納FormGroup*/
  appliInfoChild: UntypedFormGroup;

  private onDestroy$ = new Subject();

  /** 登録日 */
  tourokuYMD: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: true });
  /** 登録時刻 */
  tourokuTIME: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: true });
  /** 登録担当部署 */
  tourokuTantouBusho: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: true });
  /** 登録担当者 */
  tourokuTantosha: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: true });

  /** 最終更新日 */
  saishuKousinYMD: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: true });
  /** 最終更新時刻 */
  saishuKousinTIME: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: true });
  /** 最終更新担当部署 */
  saishuKousinTantouBusho: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: true });
  /** 最終更新担当者 */
  saishuKousinTantosha: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: true });

  /** 承認日 */
  shoninYMD: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: true });
  /** 承認時刻 */
  shoninTIME: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: true });
  /** 承認担当部署 */
  shoninTantouBusho: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: true });
  /** 承認担当者 */
  shoninTantosha: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: true });

  constructor(
    private fb: UntypedFormBuilder,
    private parent: FormGroupDirective,
    private timeApiService: TimeApiService,
  ) { }

  /**
   * 購読を停止する処理
   * @memberof Sgkb708dAppliinfoComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.appliInfoChild.clearValidators();
    this.appliInfoChild.updateValueAndValidity();
    this.appliInfoChild.removeControl('appliInfoChild');
  }

  /**
   * 初期表示処理
   * @memberof Sgkb708dAppliinfoComponent
   */
  ngOnInit(): void {
    this.appliInfoChild = this.fb.group({
      tourokuYMD: this.tourokuYMD,
      tourokuTIME: this.tourokuTIME,
      tourokuTantouBusho: this.tourokuTantouBusho,
      tourokuTantosha: this.tourokuTantosha,
      saishuKousinYMD: this.saishuKousinYMD,
      saishuKousinTIME: this.saishuKousinTIME,
      saishuKousinTantouBusho: this.saishuKousinTantouBusho,
      saishuKousinTantosha: this.saishuKousinTantosha,
      shoninYMD: this.shoninYMD,
      shoninTIME: this.shoninTIME,
      shoninTantouBusho: this.shoninTantouBusho,
      shoninTantosha: this.shoninTantosha,
    });
    //親と子の紐づけを行う。
    this.parentForm = this.parent.form;
    this.parentForm.addControl('appliInfoChild', this.appliInfoChild);

    this.configureFormControls();
  }

  /**
   * フォーム制御処理
   * @memberof Sgkb708dAppliinfoComponent
   */
  configureFormControls(): void {

    // 親コンポーネントで取得した包括契約検索APIレスポンスの業務情報を設定
    const incCtrInfoDto: Sgkb702aResInclusiveCtrInfoDto =
      this.incCtrSearchresult.inclusiveCtrInfoList[0];

    // 登録日
    this.appliInfoChild.controls['tourokuYMD'].setValue(
      this.convertToYyyyMmDd(incCtrInfoDto.torokuTimestamp));
    // 登録時刻
    this.appliInfoChild.controls['tourokuTIME'].setValue(
      this.timeApiService.convertStringToTime(incCtrInfoDto.registrationtime).slice(0, -3));
    // 登録担当部署
    this.appliInfoChild.controls['tourokuTantouBusho'].setValue(incCtrInfoDto.creatorSosikiNo);
    // 登録担当者
    this.appliInfoChild.controls['tourokuTantosha'].setValue(incCtrInfoDto.creatorStaffNo);

    // 最終更新日
    this.appliInfoChild.controls['saishuKousinYMD'].setValue(
      this.convertToYyyyMmDd(incCtrInfoDto.sshksnTstampShort));
    // 最終更新時刻
    this.appliInfoChild.controls['saishuKousinTIME'].setValue(
      this.timeApiService.convertStringToTime(incCtrInfoDto.sshksnHms).slice(0, -3));
    // 最終更新担当部署
    this.appliInfoChild.controls['saishuKousinTantouBusho'].setValue(incCtrInfoDto.lastupdatepersonSskno);
    // 最終更新担当者
    this.appliInfoChild.controls['saishuKousinTantosha'].setValue(incCtrInfoDto.lastupdatepersonStafno);

    // 承認日付
    this.appliInfoChild.controls['shoninYMD'].setValue(
      this.convertToYyyyMmDd(incCtrInfoDto.apprvDate));
    // 承認時刻
    this.appliInfoChild.controls['shoninTIME'].setValue(
      this.timeApiService.convertStringToTime(incCtrInfoDto.apprvHms).slice(0, -3));
    // 承認担当部署
    this.appliInfoChild.controls['shoninTantouBusho'].setValue(incCtrInfoDto.approverstaffnumberSskno);
    // 承認担当者
    this.appliInfoChild.controls['shoninTantosha'].setValue(incCtrInfoDto.approverstaffnumberStafno);

  }

  /**
   * 年月項目をyyyy/MM/DD形式に変換する
   * @memberof Sgkb708dAppliinfoComponent
   */
  convertToYyyyMmDd(date: string): string {
    let result = '';
    if (date && date != '') {
      const yyyy = date.slice(0, 4);
      const MM = date.slice(4, 6);
      const DD = date.slice(6, 8);
      result = yyyy + '/' + MM + '/' + DD;
    }
    return result;
  }

}
